export const SET_CUSTOM_PAGES = 'SET_CUSTOM_PAGES';
export const SET_CUSTOM_PAGE_CONTENT = 'SET_CUSTOM_PAGE_CONTENT';
export const SET_PAGE_IS_FETCHING = 'SET_PAGE_IS_FETCHING';
export const RESET_PAGES = 'RESET_PAGES';
